export default "__VITE_ASSET__87A3IKCs__"